import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appNavigationLayout]',
  standalone: true
})
export class NavigationLayoutDirective implements OnChanges {
  @Input() isCollapsed: boolean = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isCollapsed']) {
      this.updateLayout();
    }
  }

  private updateLayout(): void {
    // Set styles on the host element
    if (this.isCollapsed) {
      this.renderer.addClass(document.body, 'navigation-collapsed');
      this.renderer.setStyle(this.el.nativeElement, 'flex', '0 0 5%');
      this.renderer.setStyle(this.el.nativeElement, 'width', '5%');
      this.renderer.setStyle(this.el.nativeElement, 'min-width', '60px');
      this.renderer.setStyle(this.el.nativeElement, 'max-width', '60px');
    } else {
      this.renderer.removeClass(document.body, 'navigation-collapsed');
      this.renderer.setStyle(this.el.nativeElement, 'flex', '0 0 auto');
      this.renderer.setStyle(this.el.nativeElement, 'width', '100%');
      this.renderer.removeStyle(this.el.nativeElement, 'min-width');
      this.renderer.removeStyle(this.el.nativeElement, 'max-width');
    }

    // Update parent containers
    this.updateParentContainers();

    // Update siblings
    this.updateSiblings();

    // Force a resize event
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 50);
  }

  private updateParentContainers(): void {
    let parent = this.el.nativeElement.parentElement;

    // Walk up the DOM tree and apply styling to each parent container
    while (parent && parent !== document.body) {
      if (this.isCollapsed) {
        this.renderer.addClass(parent, 'has-collapsed-navigation');
        this.renderer.setStyle(parent, 'display', 'flex');
        this.renderer.setStyle(parent, 'flex-direction', 'row');
        this.renderer.setStyle(parent, 'width', '100%');
      } else {
        this.renderer.removeClass(parent, 'has-collapsed-navigation');
        this.renderer.removeStyle(parent, 'display');
        this.renderer.removeStyle(parent, 'flex-direction');
        this.renderer.removeStyle(parent, 'width');
      }

      parent = parent.parentElement;
    }
  }

  private updateSiblings(): void {
    const parent = this.el.nativeElement.parentElement;
    if (!parent) return;

    // Get all siblings
    const siblings = Array.from(parent.children);

    // Update each sibling that isn't the navigation
    siblings.forEach(sibling => {
      if (sibling !== this.el.nativeElement) {
        if (this.isCollapsed) {
          this.renderer.setStyle(sibling, 'flex', '1 1 95%');
          this.renderer.setStyle(sibling, 'width', '95%');
        } else {
          this.renderer.removeStyle(sibling, 'flex');
          this.renderer.removeStyle(sibling, 'width');
        }
      }
    });
  }
}
